<template>
	<div>
		<sf-search-layout>
			<el-row :gutter="3">
				<el-col :span="16">
					<search-input :label="getMessage_('QWCC000956')" paramKey="partNo" :clearable="false" :propData="partNo">
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button style="width: 110px" line icon="search" :v-if="isButton_(scrId, 'CR')" :onClick="searchMstList">{{
					getButtonMsg_(scrId, 'CR')
				}}</sf-button>
			</template>
		</sf-search-layout>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/pqy/pcku/PartCkuPrvs/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import SearchInput from '@qms/Components/SearchInput';
import partMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchInput,
		partMngPopup
	},
	data() {
		return {
			partNo: ''
		};
	},
	async created() {},
	methods: {
		...serviceMethods,
		...rootMethods,
		// setSearchParam({ key, value }) {
		// 	this.[key] = value;
		// },
		onPartPopup() {
			this.$refs.partMngPopup.open(this.partNo);
		},
		sendData(param) {
			this.partNo = param.partNo;
			// this.setSearchParam_({ key: 'partNo', value: param.partNo });
			//this.searchMstList();
		},
		async searchMstList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getPartCkuMstList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error.message || error
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed
	}
};
</script>

<style></style>
